import { Title, Grid, Text, Divider, Timeline } from "@mantine/core";
// import { ListItem } from "@mantine/core/lib/List/ListItem/ListItem";

function Experience() {
  return (
    <Grid ta="left" grow>
      <Grid.Col span={12}>
        <Title order={1} variant="gradient" size={50} mb="lg">
          Experience
        </Title>
      </Grid.Col>

      <Grid.Col span={5} ta="left">
        <Title order={3} fw={500} pb="md">
          Work
        </Title>
        <Timeline active={2} lineWidth={3}>
          <Timeline.Item
            title="XINDOTS Graphic Design Intern"
            // lineVariant="dashed"
          >
            <Text color="dimmed" size="sm">
              Crafted multitude of original marketing materials using Photoshop
              and Illustrator to boost usage of XINDOT application
            </Text>
          </Timeline.Item>

          <Timeline.Item title="Accenture Quality Engineering Intern">
            <Text color="dimmed" size="sm">
              Assisted with Regression Testing through the use of test
              automation software and data preparation
            </Text>
          </Timeline.Item>

          <Timeline.Item title="Truffle Technologies Software Development Intern">
            <Text color="dimmed" size="sm">
              Led frontend development of user-friendly web application using
              React Typescript and implemented responsive design principles to
              ensure optimal performance across all devices
            </Text>
          </Timeline.Item>
          <Timeline.Item title="Open to work!"></Timeline.Item>
        </Timeline>
      </Grid.Col>

      <Divider orientation="vertical" />

      <Grid.Col span={5}>
        <Title order={3} fw={500} pb="md" ta="right">
          Education
        </Title>
        <Timeline active={3} lineWidth={3} align="right">
          <Timeline.Item title="Unity Secondary School">
            <Text color="dimmed" size="sm">
              UNIque Productions (Multimedia Club) President
            </Text>
          </Timeline.Item>

          <Timeline.Item title="Ngee Ann Polytechnic">
            <Text color="dimmed" size="sm">
              Graduated with Diploma With Merit
              <br />
              Orientation Camp Faciliator
            </Text>
          </Timeline.Item>

          <Timeline.Item title="Singapore Management University">
            <Text color="dimmed" size="sm">
              Metamorphosis 2022 Camp Facilitator
              <br />
              MOE Uplift Programme Faciliator
              <br />
              SMU Athletics Member
              <br />
              SMU Muay Thai Member
              <br />
              SMU Golf Member
              <br />
            </Text>
          </Timeline.Item>
        </Timeline>
      </Grid.Col>
    </Grid>
  );
}

export default Experience;
